import { render, staticRenderFns } from "./order-query.vue?vue&type=template&id=2020e9dc&scoped=true&"
import script from "./order-query.vue?vue&type=script&lang=ts&"
export * from "./order-query.vue?vue&type=script&lang=ts&"
import style0 from "./order-query.vue?vue&type=style&index=0&id=2020e9dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020e9dc",
  null
  
)

export default component.exports